import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { Tooltip } from "@mui/material";
import { Fragment } from "react";

export const Equipment = {
	"*": "*",
	"PP": "For each member of the crew, a pair of protective goggles, a pair of protective gloves, a protective suit and a suitable pair of protective boots.",
	"EP": "A suitable escape device for each person on board.",
	"EX": "A gas detector.",
	"TOX": "A toximeter appropriate for the current and previous cargo, with the accessories and instructions for its use.",
	"A": "A breathing apparatus ambient air-dependent.",
} as const;

export const ProductEquipment = ({ value, onChange }: Omit<SelectProps<string, true>, "fetchOptions">) => {
	return <Select
		disableSearch
		multiple
		fetchOptions={Object.keys(Equipment)}
		value={value}
		onChange={onChange}
	/>;
};

// eslint-disable-next-line react-refresh/only-export-components
export function productEquipmentField(equipment: string | undefined | null) {
	if (!equipment) {
		return "-";
	}
	const keys = equipment.split(",").filter(s => s in Equipment) as Array<keyof typeof Equipment>;
	if (keys.length === 0) {
		return "-";
	}
	return (
		<>
			{keys.map((key, i) => (
				<Fragment key={key}>
					{i > 0 && ", "}
					{key === "*"
						? "*"
						: <Tooltip title={Equipment[key]} placement="right"><span>{key}</span></Tooltip>}
				</Fragment>
			))}
		</>
	);
}
